export type TProgramStatus = {
  label: string;
  type: 'online' | 'fidel' | 'in-store';
  subTitle: string;
  status: TProgramStatusStatus;
  cards: TCard[];
  provider: string;
  rewardStatus?: string;
};

export type TCard = {
  label: string;
  type: string;
  status: TProgramStatusStatus;
};

export type TProgramStatusStatus =
  | EProgramStatusStatus.ACTIVE
  | EProgramStatusStatus.PENDING
  | EProgramStatusStatus.FAILED
  | EProgramStatusStatus.PARTIALLY_ACTIVE;

export enum EProgramStatusStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  FAILED = 'failed',
  PARTIALLY_ACTIVE = 'partially-active',
  INACTIVE = 'inactive'
}
